import { LinearProgress, linearProgressClasses } from '@mui/material'
import styled from 'styled-components/macro'

const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
  width: '100%',
  height: 20,
  borderRadius: 5,
  [`&.${linearProgressClasses.colorPrimary}`]: {
    backgroundColor: theme.progressPrimary,
    height: 20,
  },
  [`& .${linearProgressClasses.bar}`]: {
    borderRadius: 5,
    backgroundColor: theme.removeBackground,
  },
}))
type dataPros = {
  value: any
}

const CumulativeLinearProgress = styled(LinearProgress)(({ theme }) => ({
  width: 200,
  height: 5,
  borderRadius: 5,
  [`&.${linearProgressClasses.colorPrimary}`]: {
    backgroundColor: theme.progressPrimary,
    height: 5,
  },
  [`& .${linearProgressClasses.bar}`]: {
    borderRadius: 5,
    backgroundColor: theme.cumulativeBarBg,
  },
}))

const TradeLinearProgress = styled(LinearProgress)(({ theme }) => ({
  width: 200,
  height: 5,
  borderRadius: 5,
  [`&.${linearProgressClasses.colorPrimary}`]: {
    backgroundColor: theme.progressPrimary,
    height: 5,
  },
  [`& .${linearProgressClasses.bar}`]: {
    borderRadius: 5,
    backgroundColor: theme.primaryBtn,
  },
}))

const PointProgress = styled(LinearProgress)(({ theme }) => ({
  width: 150,
  height: 4,
  borderRadius: 4,
  [`&.${linearProgressClasses.colorPrimary}`]: {
    backgroundColor: theme.progressPrimary,
    height: 4,
  },
  [`& .${linearProgressClasses.bar}`]: {
    borderRadius: 4,
    backgroundColor: '#1EA7E4',
  },
}))

const GoldProgress = styled(LinearProgress)(({ theme }) => ({
  width: 150,
  height: 4,
  borderRadius: 4,
  [`&.${linearProgressClasses.colorPrimary}`]: {
    backgroundColor: theme.progressPrimary,
    height: 4,
  },
  [`& .${linearProgressClasses.bar}`]: {
    borderRadius: 4,
    backgroundColor: '#FCFC00',
  },
}))

export default function ProgressBar({ value }: dataPros) {
  return <BorderLinearProgress variant="determinate" value={value} />
}

export function CumulativeProgressBar({ value }: dataPros) {
  return <CumulativeLinearProgress variant="determinate" value={value} />
}

export function PointProgressBar({ value }: dataPros) {
  return <PointProgress variant="determinate" value={value} />
}

export function GoldProgressBar({ value }: dataPros) {
  return <GoldProgress variant="determinate" value={value} />
}

export function TradeProgressBar({ value }: dataPros) {
  return <TradeLinearProgress variant="determinate" value={value} />
}
